define("shared/utils/caption-writer/format-tone-for-segment", ["exports", "shared/utils/constants"], function (_exports, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = getSegmentTone;
  0; //eaimeta@70e063a35619d71f0,"shared/utils/constants"eaimeta@70e063a35619d71f
  function getSegmentTone(tone) {
    if (tone === _constants.CaptionWriterTone.Casual || tone === _constants.CaptionWriterTone.Professional) {
      return tone;
    }
    return tone ? _constants.CaptionWriterTone.Custom : 'none-selected';
  }
});